// extracted by mini-css-extract-plugin
export default {"content":"KeepingPage_content__LtoUI","info-block":"KeepingPage_info-block__RR9CX"};